import React, { Component } from 'react'
import DailyTable from './tables/DailyTable.jsx'
import ShowTable from './tables/ShowTable.jsx'
import SelectType from './misc/SelectType.jsx'
import I18n from 'i18n-js'
import { InfoMessage } from '../shared/InfoMessage.jsx'

export default class BigTab extends Component {
  constructor(props) {
    super(props);
    this.getValue = this.getValue.bind(this);
    this.getInfoMessage = this.getInfoMessage.bind(this);
    this.hasStalls = this.hasStalls.bind(this);
    this.dailyTypeDisabled = this.dailyTypeDisabled.bind(this);
    this.showAssignments = this.showAssignments.bind(this);
  }

  getValue() {
    if (this.props.tab.id === "stalls") {
      return {note: this.props.summary.stallsNote,
              selectDaily: this.props.summary.stallsDailyType,
              selectShow: this.props.summary.stallsShowType,
              showTable: this.props.summary.stallsShowReservations};
    } else {
      return {note: this.props.summary.campsitesNote,
              selectDaily: this.props.summary.campsitesDailyType,
              selectShow: this.props.summary.campsitesShowType,
              showTable: this.props.summary.campsitesShowReservations};
    }
  }

  getInfoMessage() {
    if (this.props.tab.id === "stalls") {
      return this.props.summary.stallsWarning;
    } else {
      return this.props.summary.campsitesWarning;
    }
  }

  hasStalls(cost_category) {
    var hasStalls = false;
    for (let service of this.props.serviceTypes) {
      if (service[cost_category] && service[cost_category] > 0) {
        hasStalls = true;
      }
    }
    return hasStalls;
  }

  dailyTypeDisabled() {
    var service = this.props.summary.services.filter((element) =>
      element.source === `${this.props.tab.id}DailyReservations` && element.assigned)[0];
    return Boolean(service);
  }

  showAssignments() {
    var showAssigned = this.props.summary[`${this.props.tab.id}ShowAssigned`]
    if (showAssigned) {
      var uniqueAssignments = [...new Set(showAssigned.split(', '))];
      return uniqueAssignments.join(', ');
    }
  }

  render() {
    return (
      <div>
        {this.dailyTypeDisabled() || this.showAssignments() ?
          <InfoMessage message={this.getInfoMessage()} /> :
          undefined
        }
        <h4>{this.props.tab.note}</h4>
        <textarea name="note" id={`${this.props.tab.id}Note`} value={this.getValue().note} onChange={this.props.defaultChange}></textarea>
        {this.hasStalls('daily_cost') ?
          <div>
            <SelectType
              tab={this.props.tab}
              category={"Daily"}
              onChange={this.props.defaultChange}
              serviceTypes={this.props.serviceTypes}
              value={this.getValue().selectDaily}
              disabled={this.dailyTypeDisabled()}
              stallsAvailable={this.props.summary.stallsAvailable}
              campsitesAvailable={this.props.summary.campsitesAvailable}
            />
            <DailyTable
              showDays={this.props.duration.show_days}
              daysBefore={this.props.duration.days_before_show}
              daysAfter={this.props.duration.days_after_show}
              startDate={this.props.duration.start_date}
              tabId={this.props.tab.id}
              onChange={this.props.tableInputChange}
              editable={this.props.editable}
              secretary={this.props.secretary}
              summary={this.props.summary}
            />
          </div>
          : <p>Daily reservations are not available.</p>
        }
        {this.hasStalls('show_cost') ?
          <div>
            <SelectType
              tab={this.props.tab}
              category={"Show"}
              onChange={this.props.defaultChange}
              serviceTypes={this.props.serviceTypes}
              value={this.getValue().selectShow}
              stallsAvailable={this.props.summary.stallsAvailable}
              campsitesAvailable={this.props.summary.campsitesAvailable}
            />
            <ShowTable
              showDays={this.props.duration.show_days}
              daysBefore={this.props.duration.days_before_show}
              daysAfter={this.props.duration.days_after_show}
              startDate={this.props.duration.start_date}
              tabId={this.props.tab.id}
              onChange={this.props.defaultChange}
              value={this.getValue().showTable}
              editable={this.props.editable}
              secretary={this.props.secretary}
              assignments={this.showAssignments()}
              stallsAvailable={this.props.summary.stallsAvailable}
              stallShowType={this.props.summary.stallsShowType}
              campsitesAvailable={this.props.summary.campsitesAvailable}
              campsiteShowType={this.props.summary.campsitesShowType}
           />
          </div>
          : <p>Show reservations are not available.</p>
        }
      </div>
    )
  }
}
